"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _without = _interopRequireDefault(require("lodash/without"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function reducer(state, action) {
  switch (action.type) {
    case _constants.COLLAPSE_ALL:
      return _objectSpread({}, state, {
        expandedIds: []
      });

    case _constants.EXPAND_ALL:
      return _objectSpread({}, state, {
        expandedIds: state.enabledIds
      });

    case _constants.TOGGLE:
      // only toggle the item if it is enabled.
      if (state.enabledIds.includes(action.id)) {
        if (state.expandedIds.includes(action.id)) {
          return _objectSpread({}, state, {
            expandedIds: (0, _without.default)(state.expandedIds, action.id)
          });
        }

        return _objectSpread({}, state, {
          expandedIds: [].concat(_toConsumableArray(state.expandedIds), [action.id])
        });
      }

      return state;

    case _constants.UPDATE_ENABLED_IDS:
      return _objectSpread({}, state, {
        enabledIds: action.enabledIds
      });

    case _constants.UPDATE_EXPANDED_IDS:
      return _objectSpread({}, state, {
        expandedIds: action.expandedIds
      });

    default:
      return state;
  }
}

var _default = reducer;
exports.default = _default;